import { StringMap } from 'quill'

export const QUILL_MODULES_MININMAL_CONFIG: StringMap = {
	toolbar: [
		[{ header: [1, 2, 3, false] }, { font: [] }],
		['bold', 'italic', 'underline'],
		[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
		[{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
		['link', 'image'],
	],
}

export const QUILL_MODULES_EXTREME_MININMAL_CONFIG: StringMap = {
	toolbar: [
		[
			{ header: [1, 2, 3, false] },
			// , { font: [] }
		],
		['bold', 'italic', 'underline'],
		[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
		[{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
		// ['link'],
	],
}

export const QUILL_FORMATS_MINIMAL_CONFIG: string[] = [
	'font',
	'header',
	'bold',
	'italic',
	'underline',
	'strike',
	'list',
	'bullet',
	'indent',
	'link',
	'image',
	'align',
]

export const QUILL_FORMATS_EXTREME_MINIMAL_CONFIG: string[] = [
	// 'font',
	'header',
	'bold',
	'italic',
	'underline',
	'strike',
	'list',
	'bullet',
	'indent',
	'align',
]

export const QUILL_MODULES_CONFIG: StringMap = {
	toolbar: [
		[{ header: [1, 2, 3, false] }, { font: [] }],
		['bold', 'italic', 'underline'],
		[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
		[{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
		['link', 'image', 'video'],
	],
}

export const QUILL_FORMATS_CONFIG: string[] = [
	'font',
	'header',
	'bold',
	'italic',
	'underline',
	'strike',
	'blockquote',
	'list',
	'bullet',
	'indent',
	'link',
	'image',
	'video',
	'align',
]
